import { Button, Col, Row, Typography, Table } from "antd";
import type { DocumentPackage } from "@/features/supervision-cards-list";
import { EmailPushIcon, LinkIcon } from "@/shared/assets/svg/icons";
import { Chipper } from "@shared/ui";
import "./notification-related-content.scss";

export function NotificationRelatedContent({
  item,
  allPackages,
}: {
  item: DocumentPackage;
  allPackages: DocumentPackage[];
}) {
  const row = item.table?.[0];
  return (
    <div className="notification-related-content">
      <div className="notification-related-content__chips">
        {item.chippers.map((chip) => (
          <Chipper
            key={`chip-${chip.text}`}
            backgroundColor={chip.backgroundColor || "rgba(119,119,119,1)"}
          >
            {chip.text}
          </Chipper>
        ))}
      </div>

      <Typography.Title
        level={4}
        className="notification-related-content__title"
      >
        {item.title} {item.textNumber ? `№${item.textNumber}` : ""}
      </Typography.Title>

      <Row gutter={[24, 12]}>
        <Col span={6}>
          <Typography.Text type="secondary">Отправитель</Typography.Text>
          <div>{row?.sender || "-"}</div>
        </Col>
        <Col span={6}>
          <Typography.Text type="secondary">Получатель</Typography.Text>
          <div>{row?.receiver || "-"}</div>
        </Col>
        <Col span={6}>
          <Typography.Text type="secondary">Документ подписан</Typography.Text>
          <div className="notification-related-content__date-time">
            <span>{row?.documentSigned.date}</span>
            <span>{row?.documentSigned.time}</span>
          </div>
        </Col>
        <Col span={6}>
          <Typography.Text type="secondary">Письмо отправлено</Typography.Text>
          <div className="notification-related-content__date-time">
            <span>{row?.letterSent.date}</span>
            <span>{row?.letterSent.time}</span>
          </div>
        </Col>
      </Row>

      <div className="notification-related-content__file-section">
        <div>
          <div className="notification-related-content__file-header">
            <div className="notification-related-content__file-title">
              <LinkIcon />
              <div className="notification-related-content__file-title-text">
                Связанные документы
              </div>
            </div>
            <Button type="link" className="notification-related-content__view-link">
              Посмотреть
            </Button>
          </div>
        </div>
        <Table
          className="notification-related-content__table"
          rowKey={(row) => row.id}
          dataSource={getRandomRelatedMessages(allPackages, 2)}
          columns={[
            {
              title: "Название документа и тэги",
              key: "meta",
              render: (_: any, record: DocumentPackage, index: number) => (
                <div className="notification-related-content__table-meta">
                  <div className="notification-related-content__table-index">
                    {index + 1}.
                  </div>
                  <div className="notification-related-content__table-content">
                    <div className="notification-related-content__table-chips">
                      <EmailPushIcon />
                      {record.chippers.map((chip) => (
                        <Chipper
                          key={`chip-${record.id}-${chip.text}`}
                          backgroundColor={
                            chip.backgroundColor || "rgba(119,119,119,1)"
                          }
                        >
                          {chip.text}
                        </Chipper>
                      ))}
                    </div>
                    <div>{record.title}</div>
                  </div>
                </div>
              ),
            },
            {
              title: (
                <span className="notification-related-content__table-header-label">
                  Письмо отправлено
                </span>
              ),
              key: "letterSent",
              render: (_: any, record: DocumentPackage) => {
                const row = record.table?.[0];
                if (!row) return "-";
                return (
                  <div className="notification-related-content__table-date-time">
                    <span className="notification-related-content__table-date">
                      {row.letterSent.date}
                    </span>
                    <span className="notification-related-content__table-time">
                      {row.letterSent.time}
                    </span>
                  </div>
                );
              },
            },
            {
              title: (
                <span className="notification-related-content__table-header-label">
                  Дата в документе
                </span>
              ),
              key: "documentSigned",
              render: (_: any, record: DocumentPackage) => {
                const row = record.table?.[0];
                if (!row) return "-";
                return (
                  <div className="notification-related-content__table-date-time">
                    <span className="notification-related-content__table-date">
                      {row.documentSigned.date}
                    </span>
                    <span className="notification-related-content__table-time">
                      {row.documentSigned.time}
                    </span>
                  </div>
                );
              },
            },
          ]}
          pagination={false}
        />
      </div>
    </div>
  );
}

function getRandomRelatedMessages(
  allPackages: DocumentPackage[],
  count: number,
): DocumentPackage[] {
  const shuffled = [...allPackages].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
}
